<template>
  <Layout>
    <Content :style="{'padding': '10px'}">
      <Breadcrumb :style="{margin: '5px 0'}">
        <BreadcrumbItem>支付管理 > <b>云市场订单</b></BreadcrumbItem>
      </Breadcrumb>
      <Card :style="{'padding':'0px 5px','margin-bottom':'5px'}">
            <span class="search_span_width">
                <span class="search_span_width_part1">订单状态：</span>
				 <Select v-model="search.status" style="width:150px">
					 <Option value="1" :key="1">创建</Option>
				        <Option value="5" :key="5">发货</Option>
						<Option value="10" :key="10">续费</Option>
				</Select>

               <span class="search_span_width_part1">&nbsp;&nbsp;平台订单号：</span>
			  <Input v-model="search.platform_order_id" placeholder="请输入平台订单号" clearable :style="{'width':'150px'}"></Input>


            </span>
        <Button type='primary' icon="ios-search" :style="{'margin-left':'20px'}" @click="getOrderList()">搜索</Button>
      </Card>
      <Card>
        <Card id="tableContent">
          <Table :columns="tableColumns" :data="order_list"></Table>
          <Page :total="recordTotal" :current="page" :page-size="20" :show-elevator="true" @on-change="getOrderList"/>

        </Card>
      </Card>
    </Content>
    <Modal v-model="showmodal" :footer-hide=true title="绑定用户">
      <Form ref="order" :model="order" :label-width="80">
        <FormItem label="订单id" prop="content">
          <Input v-model="order.id" readonly/>
        </FormItem>
        <FormItem label="手机号">
          <Input v-model="searchUser.mobile" style="width:260px"/>
          <Button type='primary' icon="ios-search" :style="{'margin-left':'20px'}" @click="getUserList()">查询</Button>
        </FormItem>
        <FormItem label="用户id" prop="content">
          <Input v-model="order.user_id" readonly/>
        </FormItem>
        <FormItem>
          <Button type="primary" @click="updateOrder()">提交</Button>
        </FormItem>
      </Form>
    </Modal>

    <Modal
        v-model="modal1"
        title="订单发货"
        @on-ok="deliver"
        @on-cancel="cancel">
      <p>确定要为订单号是{{ order.id }}的发货吗？</p>
    </Modal>

  </Layout>
</template>
<script>
export default {
  data() {
    return {
      search: {
        status: '',
        user_id: '',
        platform_order_id: ''
      },
      searchUser: {
        mobile: '',
      },
      showmodal: false,
      modal1: false,
      recordTotal: 0,
      page: 1,
      order_list: [],
      order: {
        id: 0,
        platform_type: '',
        platform_order_id: '',
        user_id: 0,
        account_id: 0,
        product_id: 0,
        resource_id: 0,
        product_name: '',
        type: '',
        status: '',
        refund_status: '',
        refund_time: '',
        pay_time: '',
        deliver_time: '',
        expired_time: ''

      },
      tableColumns: [
        {title: 'id', key: 'id', align: 'center'},
        {
          title: '平台类型', key: 'platform_type', align: 'center', render: (h, params) => {
            var txt = '';
            if (params.row.platform_type == '1') {
              txt = '腾讯云';
            }

            return h("div", {}, txt);
          }
        },
        {title: '平台订单id', key: 'platform_order_id', align: 'center'},
        {title: '用户id', key: 'user_id', align: 'center'},
        {title: '用户手机号', key: 'mobile', align: 'center'},
        {title: '平台账号id', key: 'account_id', align: 'center'},

        {title: '云市场产品id', key: 'product_id', align: 'center'},
        {title: '云市场的实例id', key: 'resource_id', align: 'center'},
        {title: '购买的产品名称', key: 'product_name', align: 'center'},
        {title: '实例过期时间', key: 'expired_time', align: 'center'},
        {title: '发货时间', key: 'deliver_time', align: 'center'},
        {title: '创建时间', key: 'created_at', align: 'center'},
        {
          title: '状态', key: 'status', align: 'center', render: (h, params) => {
            var txt = '';
            if (params.row.status == '1') {
              txt = '创建';
            } else if (params.row.status == '5') {
              txt = '已发货';
            } else if (params.row.status == '10') {
              txt = '续费';
            }
            return h("div", {}, txt);
          }
        },
        {
          title: '操作', key: 'action', align: 'center',
          render: (h, params) => {
            let btns = []
            if (params.row.user_id <= 0) {
              btns.push(
                  h('Button', {
                    props: {type: 'warning', size: 'small'},
                    style: {marginRight: '5px', marginBottom: '5px'},
                    on: {
                      click: () => {
                        this.order.id = params.row.id;
                        this.order.platform_type = params.row.platform_type;
                        this.order.platform_order_id = params.row.platform_order_id;
                        this.order.user_id = params.row.user_id;
                        this.order.account_id = params.row.account_id;
                        this.order.resource_id = params.row.resource_id;
                        this.order.product_name = params.row.product_name;
                        this.order.type = params.row.type;
                        this.order.refund_status = params.row.refund_status;
                        this.order.refund_time = params.row.refund_time;
                        this.order.pay_time = params.row.pay_time;
                        this.order.deliver_time = params.row.deliver_time;
                        this.order.expired_time = params.row.expired_time;
                        this.searchUser.mobile = '';
                        this.order.status = params.row.status.toString();
                        this.showmodal = true;
                      }
                    }
                  }, '绑定用户'),
              );
            }
            if (params.row.status == '1') {
              btns.push(
                  h('Button', {
                    props: {type: 'success', size: 'small'},
                    style: {marginRight: '5px', marginBottom: '5px'},
                    on: {
                      click: () => {
                        this.order.id = params.row.id;
                        this.order.platform_type = params.row.platform_type;
                        this.order.platform_order_id = params.row.platform_order_id;
                        this.order.user_id = params.row.user_id;
                        this.order.account_id = params.row.account_id;
                        this.order.resource_id = params.row.resource_id;
                        this.order.product_name = params.row.product_name;
                        this.order.type = params.row.type;
                        this.order.refund_status = params.row.refund_status;
                        this.order.refund_time = params.row.refund_time;
                        this.order.pay_time = params.row.pay_time;
                        this.order.deliver_time = params.row.deliver_time;
                        this.order.expired_time = params.row.expired_time;

                        this.order.status = params.row.status.toString();
                        this.modal1 = true;
                      }
                    }
                  }, '发货'),
              );
            }

            return h("div", btns);
          }
        }
      ],
    }
  },
  mounted: function () {
    this.getOrderList();
  },
  computed: {},
  methods: {
    deliver() {
      this.http1.post('/platform/deliver', {'order_id': this.order.id}).then(response => {
        let data = response.data;
        if (data.code !== 0) {
          alert(data.message);
        } else {
          this.$Message.success('操作成功');
          this.getOrderList();
        }
      }).catch(() => {
        this.$Message.error('网络错误');
      });
    },
    cancel() {
    },
    updateOrder() {
      this.http1.post('/platform/edit', {
        order_id: this.order.id,
        user_id: this.order.user_id
      }).then(response => {
        let data = response.data;
        if (data.code !== 0) {
          this.$Message.error(data.message);
          return false;
        } else {
          this.$Message.info(data.message);
          this.showmodal = false;
          this.getOrderList();
          return true;
        }
      });
    },
    getOrderList(page = this.page) {
      this.page = page;
      let p = {'page': page}
      let params = Object.assign(this.search, p);
      this.http1.get('/platform/list', {params: params}).then(response => {
        let data = response.data;
        if (data.code !== 0) {
          alert(data.message);
        } else {
          this.order_list = data.res.list;
          this.recordTotal = data.res.total;
        }
      }).catch(() => {
        this.$Message.error('网络错误');
      });
    },
    getUserList() {
      let p = {'page': 1}
      let params = Object.assign(this.searchUser, p);
      this.http.get('/admin/user/userList', {params: params}).then(response => {
        let data = response.data;
        if (data.code !== 0) {
          alert(data.message);
        } else {
          if (data.data.total >= 1) {
            this.order.user_id = data.data.list[0].id;
          } else {
            alert('用户信息不存在');
            this.order.user_id = 0;
          }

        }
      }).catch(() => {
        this.$Message.error('网络错误');
      });
    },
  }
}
</script>
